module.exports = __webpack_public_path__ + "static/media/29DUNON1.5f87cf40.jpg";